import { HttpClient } from '@angular/common/http'
import { Router } from '@angular/router'
import { APP_CONFIG } from 'src/app/app.config'
import { AppConfigModel } from 'src/app/core/models'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { MapEventsService } from 'src/app/core/services/map-events.service'
import { MapService } from 'src/app/core/services/map.service'
import { Layers } from '../layers-config/layers'
import { LayerNonDetectionsService } from '../layers/layer-non-detections.service'
import { DataNonDetectionsService } from '../services/data-non-detections.service'

export const nonDetectionsLayerProvider = {
  provide: 'nonDetectionsLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerNonDetectionsService =>
    new LayerNonDetectionsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.NonDetections.name,
      16,
      16,
      14,
      new DataNonDetectionsService(http, config),
    ),
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}
